import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    popupPaper: {
      borderRadius: 15,
    },
    legendListIcon: {
      width: 16,
      border: 'solid 1px #b8b8b8',
      height: 16,
      opacity: 1,
      flexGrow: 0,
      marginInlineEnd: 10,
      borderRadius: '50%',
      display: 'inline-block',

      '@media (max-width: 840px)': {
        marginInlineEnd: 6,
      },
    },
    legendIb: {
      backgroundColor: variables.orchid,
    },
    legendMasterIb: {
      backgroundColor: variables.oceanGreen,
    },
    legendSubIb: {
      backgroundColor: variables.ultramarineBlue,
    },
    legendPrime: {
      backgroundColor: variables.yellowRed,
    },
    legendMlm: {
      backgroundColor: variables.darkPastelRed,
    },
    legendTerminated: {
      backgroundColor: variables.black20,
    },
    checkbox: {
      minWidth: 30,
      '& .MuiCheckbox-colorSecondary.Mui-checked': {
        color: '#3BBB7A',
      },
      '& .MuiIconButton-edgeStart': {
        marginInlineStart: '-12px',
      },
    },
  }),
);
